import React from 'react';
import 'twin.macro';
import { MenuHeader, MenuContent } from '.';
import { menuStyle, opacityStyle, MenuNavLink } from '../linktypes';
import { TextLine } from '../text';

export const PrivacyMenu = () => {
  return (
    <>
      <MenuHeader title='Privacy & info' />
      <MenuContent>
        <MenuNavLink label='Privacy & Cookies' to='/privacy' />

        <div css={[menuStyle, opacityStyle]} onClick={() => window.Didomi.preferences.show()}>
          <TextLine text='Privacy instellingen' />
        </div>
        <MenuNavLink label='Huisregels' to='/huisregels' />
        <MenuNavLink label='Algemene Voorwaarden' to='/algemene-voorwaarden' />
        <MenuNavLink label='Veelgestelde vragen' to='/veelgestelde-vragen' />
        <MenuNavLink label='Verordening digitale diensten' to='/verordening-digitale-diensten' />
        <div css={[menuStyle, opacityStyle]}>
          <a href='https://www.mediahuis.nl/merken/dumpert/' target='_blank' rel='noreferrer'>
            <TextLine text='Adverteren' />
          </a>
        </div>
      </MenuContent>
    </>
  );
};
